/**
 * Composes several functions to form one function. Value passes from left to right.
 *
 * @param fns - functions to compose
 */ export default function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.reduce(function(prevFn, nextFn) {
        return function(value) {
            return nextFn(prevFn(value));
        };
    }, function(value) {
        return value;
    });
};
